import React from "react";
import { Field, ErrorMessage } from "formik";
import { FormikReactSelect } from "../../common/FormikReactSelect";
import { FormikCreateableMultiSelect } from "../../common/FormikCreateableMultiSelect";
import { Styles } from "react-select";

interface ItemDetailsPageProps {
  selectCustomStyles?: Partial<Styles>;
};

export const ItemDetailsPage = ({ selectCustomStyles }: ItemDetailsPageProps) => (
<>
  <Field type="text" name="sku" placeholder='SKU' />
  <ErrorMessage name="sku" component="div" />
  <Field type="text" name="cost" placeholder='Cost' />
  <ErrorMessage name="cost" component="div" />
  <Field type="text" name="price" placeholder='Price' />
  <ErrorMessage name="price" component="div" />
  <Field name="barcodeType" as={FormikReactSelect} options={[
    { value: 'UPC', label: 'UPC' },
    { value: 'ISBN', label: 'ISBN' },
    { value: 'EAN', label: 'EAN' },
    { value: 'No Barcode', label: 'No Barcode' },
  ]} customStyles={selectCustomStyles} placeholder="Barcode Type" />
  <ErrorMessage name="category" component="div" />
  <Field type="text" name="barcode" placeholder='Barcode' />
  <ErrorMessage name="barcode" component="div" />
  <Field type="text" name="width" placeholder='Width (in)' />
  <ErrorMessage name="width" component="div" />
  <Field type="text" name="length" placeholder='Length (in)' />
  <ErrorMessage name="length" component="div" />
  <Field type="text" name="depth" placeholder='Depth (in)' />
  <ErrorMessage name="depth" component="div" />
  <Field name="ingredients" as={FormikCreateableMultiSelect} customStyles={selectCustomStyles} placeholder="Ingredients" />
  <ErrorMessage name="ingredients" component="div" />
</>
);
